"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluggableFunnelChart = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = require("react-dom");
var PluggablePieChart_1 = require("../pieChart/PluggablePieChart");
var funnelChartUiConfigHelper_1 = require("../../../utils/uiConfigHelpers/funnelChartUiConfigHelper");
var UnsupportedConfigurationPanel_1 = tslib_1.__importDefault(require("../../configurationPanels/UnsupportedConfigurationPanel"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var PluggableFunnelChart = /** @class */ (function (_super) {
    tslib_1.__extends(PluggableFunnelChart, _super);
    function PluggableFunnelChart(props) {
        var _this = _super.call(this, props) || this;
        _this.type = sdk_ui_1.VisualizationTypes.FUNNEL;
        return _this;
    }
    PluggableFunnelChart.prototype.getExtendedReferencePoint = function (referencePoint) {
        return _super.prototype.getExtendedReferencePoint.call(this, referencePoint).then(funnelChartUiConfigHelper_1.setFunnelChartUiConfig);
    };
    PluggableFunnelChart.prototype.renderConfigurationPanel = function () {
        var _a;
        if (document.querySelector(this.configPanelElement)) {
            var properties = (_a = this.visualizationProperties) !== null && _a !== void 0 ? _a : {};
            react_dom_1.render(react_1.default.createElement(UnsupportedConfigurationPanel_1.default, { locale: this.locale, pushData: this.pushData, properties: properties }), document.querySelector(this.configPanelElement));
        }
    };
    return PluggableFunnelChart;
}(PluggablePieChart_1.PluggablePieChart));
exports.PluggableFunnelChart = PluggableFunnelChart;
//# sourceMappingURL=PluggableFunnelChart.js.map